import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { isRouteGuardException, isRoutePolicyAllowed, resolveRoutePolicy } from '@lms/shared-types';
import { usePermissions } from '@/hooks/usePermissions';

const UNGUARDED_PATHS = new Set(['/acceso-denegado', '/403']);

export function RouteAccessGuard() {
  const { pathname } = useLocation();
  const { hasPermission, hasAnyPermission, canAccessAdmin } = usePermissions();

  if (UNGUARDED_PATHS.has(pathname) || isRouteGuardException(pathname)) {
    return <Outlet />;
  }

  const policy = resolveRoutePolicy(pathname);
  if (!policy) {
    return <Navigate to="/acceso-denegado" replace />;
  }

  const allowed = isRoutePolicyAllowed(policy, {
    hasPermission,
    hasAnyPermission,
    canAccessAdmin,
  });

  if (!allowed) {
    return <Navigate to="/acceso-denegado" replace />;
  }

  return <Outlet />;
}
